import { DataFormClient } from "@affinitysystemsgroup/github-packages-affinity-components/dist";

export const identificationTypeDataForm: DataFormClient = {
  id: "",
  Description: "",
  Code: "",
  // MaxCharacter: 0,
  // MinCharacter: 0,
  // IsNumeric: false
};